<form  [formGroup]="searchTemplateForm"  *ngIf="searchTemplateForm" class="mt-4">
    <div class="row">
              <div class="col-sm-4" > Search SubTopics</div>
              <div class="col-sm-4" >
                  <input   formControlName="searchInput" class="form-control"/>
              </div>
       </div>
  </form>
  <ul>
      <li *ngFor="let subtopic of subtopicList;" style="list-style: none;">
      <a [routerLink]="['/admin/subtopic/show',subtopic.id]"> {{subtopic.text}}</a>
  </li>
  </ul>
